<template>
  <div>
    <bannerS class="nav"></bannerS>
    <navS :class="{ 'fixed-nav': navFixed }"></navS>
    <router-view></router-view>
    <model></model>
    <footerS></footerS>
  </div>
</template>

<script>
import bannerS from "./components/bannerS.vue";
import navS from "./components/navS.vue";
import footerS from "./components/footerS";

export default {
  components: {
    bannerS,
    navS,
    footerS
  },
  data() {
    return {
      navFixed: false
    };
  },
  mounted() {
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 容器的高度
      var offsetTop = document.querySelector(".nav").offsetHeight;
      // console.log("scrollTop=>", scrollTop, "  offsetTop=>", offsetTop)
      //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if (scrollTop > offsetTop) {
        GMS.vbus.$emit("change-color", { state: false });
        this.navFixed = true;
      } else {
        GMS.vbus.$emit("change-color", { state: true });
        this.navFixed = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.fixed-nav {
  position: sticky;
  top: 0;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/portal.vue